export type PurchaseNotification = {
  id: string
  firstName: string
  location: string
}

/**
 * Placeholder feed for the purchase notification component.
 *
 * These entries are NOT real transactions — they exist so the component can be
 * previewed. In production, replace `defaultPurchaseFeed` with data loaded from
 * real order records or an approved external data source, keeping the same
 * `PurchaseNotification` shape.
 */
export const defaultPurchaseFeed: PurchaseNotification[] = [
  { id: 'sample-1', firstName: 'Michael R.', location: 'Austin, TX' },
  { id: 'sample-2', firstName: 'James T.', location: 'Manchester, UK' },
  { id: 'sample-3', firstName: 'Chris M.', location: 'Toronto, Canada' },
  { id: 'sample-4', firstName: 'Daniel K.', location: 'Brisbane, Australia' },
  { id: 'sample-5', firstName: 'Brian S.', location: 'Columbus, OH' },
  { id: 'sample-6', firstName: 'Aaron W.', location: 'Leeds, UK' },
  { id: 'sample-7', firstName: 'Kevin D.', location: 'Calgary, Canada' },
  { id: 'sample-8', firstName: 'Sean O.', location: 'Dublin, Ireland' },
  { id: 'sample-9', firstName: 'Tyler B.', location: 'Charlotte, NC' },
  { id: 'sample-10', firstName: 'Nathan P.', location: 'Auckland, NZ' },
  { id: 'sample-11', firstName: 'Marcus H.', location: 'Indianapolis, IN' },
  { id: 'sample-12', firstName: 'Ryan C.', location: 'Melbourne, Australia' },
  { id: 'sample-13', firstName: 'Andrew L.', location: 'Glasgow, UK' },
  { id: 'sample-14', firstName: 'Jordan F.', location: 'Phoenix, AZ' },
]
